import React, {useState} from "react";
import { toBase64 } from "../../../fuse/utils";
import { DropzoneAreaBase } from "material-ui-dropzone";
import GlobalState, {
  changeAttachName, 
  changePortraitsheduledeploycred, 
  changePortraitsheduledeployname, 
  changesegmentationpage, 
  changeInputDataset} from "../../../stores/GlobalState";
import lang from "../../../lang"
import Loading from '../../common/loading';
import LoadingCompleted from '../../common/loading_completed';
import LoadingFail from '../../common/loading_fail';


export default function AttachmentBox ({ attachments, setAttachments, setStatehead,  nameDatasetprew, load, setLoad }) {
  const sizeInMB = (sizeInBytes) => {
    return (sizeInBytes / (1024 * 1024)).toFixed(2);
  };
  
  const handleFileDelete = (file, arg2, arg3) => {};
  const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
  const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
  const [textloading, setTextloading] = useState("Uploading");
  const [textloadingcompleated, setTextloadingcompleated] = useState("Uploaded");
  const [attach, setAttach]= useState([])
  const handleFilesChange = async (files) => {
    if (!files.length === 0) {
      return;
    }

    const filesToUpload = [];

    for (const file of files) {


      const fileContent = await toBase64(file);
      const fileExtension = file.name.split(".").pop();
      const fileName = file.name;
      const fileSize = sizeInMB(file.size);

      filesToUpload.push({
        file_content: fileContent,
        file_extension: fileExtension,
        file_name: fileName,
        file_path: fileName,
        file_size: fileSize,
        file_type: 2,
        file: file,
      });
    }
    setAttachments(filesToUpload);
    setAttach(e);
  };

  const adddatasetprewWorkspacecheck = async (a) => {
  
    setTextloadingcompleated('Processing the saving of deployment')
    var token = localStorage.getItem("token");
    changeInputDataset("");
    var name = nameDatasetprew.replace(" ", "");
    changePortraitsheduledeploycred(JSON.parse(a));
    changePortraitsheduledeployname(nameDatasetprew);
    setTimeout(function(){
      changesegmentationpage(7)
    }, 2000)
    
}

  const onDrop = async(e)=> {
    if(nameDatasetprew!='')
    {
      //changesegmentationpage(11)
      const fileReader = new FileReader();
      changeAttachName(e);
      setAttach(e);
      fileReader.readAsText(e[0]);

      fileReader.onload = () => {
        adddatasetprewWorkspacecheck(fileReader.result);
      };
    }
  };


  return (
    <div className="my-14 px-10 zeras preloadbigdataset bq_load zeras" >
      {
        load==1?
        <div style={{marginTop:"150px"}}>
          <Loading text = {textloading}/>
        </div>
       
        :
        load==2?
        <LoadingCompleted text = {textloadingcompleated}/>
        :
        load==4?
        <LoadingFail text = {textloadingcompleated}/>
        :
        <div className={GlobalState.portraitsheduledeployname=='' ? "inactive":""} >
          <DropzoneAreaBase
            initialFiles={attachments}
            acceptedFiles={['.csv, .json']}
            filesLimit={1}
            maxFileSize={5368709120}
            clearOnUnmount={false}
            dropzoneClass="min-h-88"
            onDelete={handleFileDelete}
            onChange={handleFilesChange}
            dropzoneText={dropzoneText(nameDatasetprew, attachments, attach)}
            showPreviewsInDropzone={false}
            showPreviews={false}
            Icon="none"
            onDrop={(e) => onDrop(e)}
            
          />
        </div>
   
      }
      
    </div>
  );
}

const dropzoneText = (nameDatasetprew, attachments, attach) => {
  var langv = lang.en
  return (
    attach.length>0?
        
        <div className="text-center my-16 dropanddrag">
          <div className="text_done_name" >{attach.map((file, index) => (<>{file.name}</>))}</div>
          
          <div className="buttom_dropanddrag_line">
            <div className="buttom_dropanddrag">{langv?.dataset?.popupadddataset?.text7}</div>
          </div>
          
        </div>
        :
    <>
      <div className="text-center my-16 dropanddrag">
        <div className="title_dropanddrag" >
         {langv?.dataset?.popupadddataset?.text4}
        </div>
        <p className="text_dropanddrag">
        {langv?.dataset?.popupadddataset?.text6}
        </p>
        <div className="buttom_dropanddrag_line">
          <div className="buttom_dropanddrag">{langv?.dataset?.popupadddataset?.text7}</div>
        </div>
        
      </div>
    </>
  );
};



